import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const ChemicalsPaperAndRubberIndustry = ({ rawUrl }) => {

    //// Split the raw URL to determine the location
    //const ll = rawUrl.split('/').length;
    //let loc = '';
    //if (ll === 4) {
    //    loc = ' in ' + rawUrl.split('/')[ll - 1];
    //}

    //// Set dynamic title and meta description
    //const pageTitle = `Best ERP Software for Automobile${loc} | Best Automotive ERP Software${loc} | Business Management Solutions - Tejaxo Software`;
    //const metaDesc = `Tejaxo Software is a High Rated Indian ERP and BI software development company${loc}, providing award-winning Enterprise Resource Planning (ERP) software${loc}, business management solutions, services and support.`;
    //const metaKey = "Tejaxo Software, Tejaxo ERP, ERP Software, Tejaxo BI, School ERP, School Software";
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/chemicals-rubber-1-1024x683.jpg" alt="Chemicals Rubber Industries" />
                    </div>
                        <div className="col-lg-6 content">
                            <h1 className="elementor-heading-title elementor-size-default">Chemicals, Paper &amp; Rubber Industries{state.condText}</h1>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <h2 className="elementor-heading-title elementor-size-default">
                            While the chemicals, paper and rubber industries provide essential materials to many sectors,
                        </h2>
                        <p style={{ fontWeight: 400 }}>
                            The demand for these materials is waning as consumer preferences shift. As production volumes decline, businesses need to actively engage the trade to drive demand and capitalise on existing opportunities, while keeping their costs down to remain productive in a highly competitive environment. As in any highly-regulated environment, you need to drive production efficiencies while finding ways to meet robust environmental standards e.g. effluent discharge, noise and air pollution.
                        </p>
                    </div>
                    <div className="col-lg-6 content">
                        <img src="/theme/img/chemicals-rubber-2-768x512.jpg" alt="Production Efficiency" />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/bdimg1.PNG" alt="Tejaxo Software" />
                    </div>
                    <div className="col-lg-6 content">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Tejaxo Software can help drive your efficiency by providing you with simple tools to enhance your productivity and reduce costs.
                        </h2>
                        <p style={{ fontWeight: 400 }}>
                            Integrate your systems and databases to improve communication across your business, driving significant improvements in productivity, while collecting actionable insights to enable you to continuously optimise production. Our easy to use online solutions such as eCommerce and EDI ensure you are always across your financial performance and can easily estimate profitability, while important relationships with customers and key suppliers are maintained with special pricing and promotions, tailored specifically for your needs � no promo or pricing structure is too complex for our system.
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default ChemicalsPaperAndRubberIndustry;
